import { useEffect } from 'react';

import get from 'lodash/get';

import {
  COUNTRY,
  FRAUD_PROTECTION_COUNTRIES,
  INSTALLS_FRAUD,
  REGISTRATIONS_FRAUD,
} from '../constants';

export const useFraudPresetValues = ({
  withRegistrationsFraud,
  withInstallsFraud,
  values,
  setFieldValue,
}) => {
  const countryId = values[COUNTRY];

  useEffect(() => {
    const registrationFraudPath = `${REGISTRATIONS_FRAUD}.${FRAUD_PROTECTION_COUNTRIES}`;

    if (withRegistrationsFraud && !get(values, registrationFraudPath)) {
      setFieldValue(registrationFraudPath, [countryId]);
    }
  }, [countryId, withRegistrationsFraud]);

  useEffect(() => {
    const installsFraudPath = `${INSTALLS_FRAUD}.${FRAUD_PROTECTION_COUNTRIES}`;

    if (withInstallsFraud && !get(values, installsFraudPath)) {
      setFieldValue(installsFraudPath, [countryId]);
    }
  }, [countryId, withInstallsFraud]);
};

export default useFraudPresetValues;
